import { config } from 'config/constants';
import { IAppReducer } from 'models';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useSettingsOptions } from '../Settings-options/hooks/useSettingsOptions';

export const Dashboard = () => {
  const navigate = useNavigate();
  const { authReducer: user } = useSelector((state: IAppReducer) => state);
  const { handleSignOut } = useSettingsOptions();

  if (
    user.countryAcronym?.toLocaleLowerCase() !== 'pr' ||
    user.role?.toLocaleLowerCase() !== 'authenticated'
  ) {
    navigate('/settings');
  }

  const authId = user.uid;
  const jwt = user.accessToken;

  const iframeUrl = `${
    config.soda.sodaUrl
  }/dashboard?authId=${encodeURIComponent(authId)}&token=${encodeURIComponent(
    jwt
  )}`;

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== config.soda.sodaUrl) {
        return;
      }

      if (event.data?.type === `LOGOUT_FROM_IFRAME_${authId}`) {
        handleSignOut();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [handleSignOut]);

  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <iframe
        src={iframeUrl}
        width="100%"
        height="100%"
        title="Dashboard"
        style={{ border: 'none' }}
      />
    </div>
  );
};
